// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "" + {"126": "dingtalk-jsapi","257": "customize","28": "light-component","417": "i18next","516": "ali-oss","749": "@sentry/react",}[chunkId] + "." + {"126": "114bee17","257": "658f97fc","28": "3097f83e","417": "dce58ccb","516": "855c9ba0","749": "e89aab5c",}[chunkId] + ".js"
}